import { useMemo } from 'react';
import { IColumn } from '../../types';

export const normalizeColumns = (
  columns: IColumn[] | Record<string, IColumn> | undefined
): IColumn[] => {
  if (!columns || typeof columns === 'string') return [];
  if (Array.isArray(columns)) return columns;
  return Object.values(columns).sort(
    (a, b): number => (a.order ?? 0) - (b.order ?? 0)
  );
};

const useNormalizeColumns = (columns: IColumn[] | Record<string, IColumn>) =>
  useMemo(() => normalizeColumns(columns), [columns]);

export default useNormalizeColumns;
